const States = [
    {
        "name": "Alabama",
        "code": "01",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "code": "02",
        "abbreviation": "AK"
    },
    {
        "name": "Arizona",
        "code": "04",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "code": "05",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "code": "06",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "code": "08",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "code": "09",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "code": "10",
        "abbreviation": "DE"
    },
    {
        "name": "DISTRICT OF COLUMBIA",
        "code": "11",
        "abbreviation": "DC"
    },
    {
        "name": "Florida",
        "code": "12",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "code": "13",
        "abbreviation": "GA"
    },
    {
        "name": "Hawaii",
        "code": "15",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "code": "16",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "code": "17",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "code": "18",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "code": "19",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "code": "20",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "code": "21",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "code": "22",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "code": "23",
        "abbreviation": "ME"
    },
    {
        "name": "Maryland",
        "code": "24",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "code": "25",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "code": "26",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "code": "27",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "code": "28",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "code": "29",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "code": "30",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "code": "31",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "code": "32",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "code": "33",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "code": "34",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "code": "35",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "code": "36",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "code": "37",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "code": "38",
        "abbreviation": "ND"
    },
    {
        "name": "Ohio",
        "code": "39",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "code": "40",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "code": "41",
        "abbreviation": "OR"
    },
    {
        "name": "Pennsylvania",
        "code": "42",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "code": "72",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "code": "44",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "code": "45",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "code": "46",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "code": "47",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "code": "48",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "code": "49",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "code": "50",
        "abbreviation": "VT"
    },
    {
        "name": "Virginia",
        "code": "51",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "code": "53",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "code": "54",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "code": "55",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "code": "56",
        "abbreviation": "WY"
    }
]

export default States;
